/**
 * An immutable Record that maps ISO 3166-1 country codes to the ISO 4217 currency
 * code for that country's national/preferred currency.
 */
export const countryCodeToCurrencyCode = {
    AF: 'AFN',
    AX: 'EUR',
    AL: 'ALL',
    DZ: 'DZD',
    AS: 'USD',
    AD: 'EUR',
    AO: 'AOA',
    AI: 'XCD',
    AQ: 'USD',
    AG: 'XCD',
    AR: 'ARS',
    AM: 'AMD',
    AW: 'AWG',
    AU: 'AUD',
    AT: 'EUR',
    AZ: 'AZN',
    BS: 'BSD',
    BH: 'BHD',
    BD: 'BDT',
    BB: 'BBD',
    BY: 'BYN',
    BE: 'EUR',
    BZ: 'BZD',
    BJ: 'XOF',
    BM: 'BMD',
    BT: 'BTN',
    BO: 'BOB',
    BQ: 'USD',
    BA: 'BAM',
    BW: 'BWP',
    BV: 'NOK',
    BR: 'BRL',
    IO: 'USD',
    BN: 'BND',
    BG: 'EUR',
    BF: 'XOF',
    BI: 'BIF',
    CV: 'CVE',
    KH: 'KHR',
    CM: 'XAF',
    CA: 'CAD',
    KY: 'KYD',
    CF: 'XAF',
    TD: 'XAF',
    CL: 'CLP',
    CN: 'CNY',
    CX: 'AUD',
    CC: 'AUD',
    CO: 'COP',
    KM: 'KMF',
    CD: 'CDF',
    CG: 'XAF',
    CK: 'NZD',
    CR: 'CRC',
    CI: 'XOF',
    HR: 'EUR',
    CU: 'CUP',
    CW: 'XCG',
    CY: 'EUR',
    CZ: 'CZK',
    DK: 'DKK',
    DJ: 'DJF',
    DM: 'XCD',
    DO: 'DOP',
    EC: 'USD',
    EG: 'EGP',
    SV: 'USD',
    GQ: 'XAF',
    ER: 'ERN',
    EE: 'EUR',
    SZ: 'SZL',
    ET: 'ETB',
    FK: 'FKP',
    FO: 'DKK',
    FJ: 'FJD',
    FI: 'EUR',
    FR: 'EUR',
    GF: 'EUR',
    PF: 'XPF',
    TF: 'EUR',
    GA: 'XAF',
    GM: 'GMD',
    GE: 'GEL',
    DE: 'EUR',
    GH: 'GHS',
    GI: 'GIP',
    GR: 'EUR',
    GL: 'DKK',
    GD: 'XCD',
    GP: 'EUR',
    GU: 'USD',
    GT: 'GTQ',
    GG: 'GBP',
    GN: 'GNF',
    GW: 'XOF',
    GY: 'GYD',
    HT: 'HTG',
    HM: 'AUD',
    VA: 'EUR',
    HN: 'HNL',
    HK: 'HKD',
    HU: 'HUF',
    IS: 'ISK',
    IN: 'INR',
    ID: 'IDR',
    IR: 'IRR',
    IQ: 'IQD',
    IE: 'EUR',
    IM: 'GBP',
    IL: 'ILS',
    IT: 'EUR',
    JM: 'JMD',
    JP: 'JPY',
    JE: 'GBP',
    JO: 'JOD',
    KZ: 'KZT',
    KE: 'KES',
    KI: 'AUD',
    KP: 'KPW',
    KR: 'KRW',
    KW: 'KWD',
    KG: 'KGS',
    LA: 'LAK',
    LV: 'EUR',
    LB: 'LBP',
    LS: 'LSL',
    LR: 'LRD',
    LY: 'LYD',
    LI: 'CHF',
    LT: 'EUR',
    LU: 'EUR',
    MO: 'MOP',
    MG: 'MGA',
    MW: 'MWK',
    MY: 'MYR',
    MV: 'MVR',
    ML: 'XOF',
    MT: 'EUR',
    MH: 'USD',
    MQ: 'EUR',
    MR: 'MRU',
    MU: 'MUR',
    YT: 'EUR',
    MX: 'MXN',
    FM: 'USD',
    MD: 'MDL',
    MC: 'EUR',
    MN: 'MNT',
    ME: 'EUR',
    MS: 'XCD',
    MA: 'MAD',
    MZ: 'MZN',
    MM: 'MMK',
    NA: 'NAD',
    NR: 'AUD',
    NP: 'NPR',
    NL: 'EUR',
    NC: 'XPF',
    NZ: 'NZD',
    NI: 'NIO',
    NE: 'XOF',
    NG: 'NGN',
    NU: 'NZD',
    NF: 'AUD',
    MK: 'MKD',
    MP: 'USD',
    NO: 'NOK',
    OM: 'OMR',
    PK: 'PKR',
    PW: 'USD',
    PS: 'ILS',
    PA: 'USD',
    PG: 'PGK',
    PY: 'PYG',
    PE: 'PEN',
    PH: 'PHP',
    PN: 'NZD',
    PL: 'PLN',
    PT: 'EUR',
    PR: 'USD',
    QA: 'QAR',
    RE: 'EUR',
    RO: 'RON',
    RU: 'RUB',
    RW: 'RWF',
    BL: 'EUR',
    SH: 'SHP',
    KN: 'XCD',
    LC: 'XCD',
    MF: 'EUR',
    PM: 'EUR',
    VC: 'XCD',
    WS: 'WST',
    SM: 'EUR',
    ST: 'STN',
    SA: 'SAR',
    SN: 'XOF',
    RS: 'RSD',
    SC: 'SCR',
    SL: 'SLE',
    SG: 'SGD',
    SX: 'XCG',
    SK: 'EUR',
    SI: 'EUR',
    SB: 'SBD',
    SO: 'SOS',
    ZA: 'ZAR',
    GS: 'GBP',
    SS: 'SSP',
    ES: 'EUR',
    LK: 'LKR',
    SD: 'SDG',
    SR: 'SRD',
    SJ: 'NOK',
    SE: 'SEK',
    CH: 'CHF',
    SY: 'SYP',
    TW: 'TWD',
    TJ: 'TJS',
    TZ: 'TZS',
    TH: 'THB',
    TL: 'USD',
    TG: 'XOF',
    TK: 'NZD',
    TO: 'TOP',
    TT: 'TTD',
    TN: 'TND',
    TR: 'TRY',
    TM: 'TMT',
    TC: 'USD',
    TV: 'AUD',
    UG: 'UGX',
    UA: 'UAH',
    AE: 'AED',
    GB: 'GBP',
    UM: 'USD',
    US: 'USD',
    UY: 'UYU',
    UZ: 'UZS',
    VU: 'VUV',
    VE: 'VED',
    VN: 'VND',
    VG: 'USD',
    VI: 'USD',
    WF: 'XPF',
    EH: 'MAD',
    YE: 'YER',
    ZM: 'ZMW',
    ZW: 'ZWG',
};
const currencyCodeToCountryCodeList = Object.freeze(Object.entries(countryCodeToCurrencyCode).reduce((acc, [country, currency]) => {
    ;
    (acc[currency] ??= []).push(country);
    return acc;
}, {}));
/**
 * Returns the preferred national currency for the specified country.
 *
 * @param country A {@link CountryCode}
 * @return The {@link CurrencyCode} of the country's national currency
 */
export const getCurrencyForCountry = (country) => countryCodeToCurrencyCode[country];
/**
 * Returns the countries using the specified currency. While most currencies are
 * 1:1 with a country, some (EUR, USD, XAF, etc) are used in multiple countries.
 *
 * @param currency A {@link CurrencyCode}
 * @return An array of {@link CountryCode}(s) for countries using the currency
 */
export const getCountriesUsingCurrency = (currency) => currencyCodeToCountryCodeList[currency];
//# sourceMappingURL=countryCurrencyMappings.js.map